/**
 * Enhancement for <input type=tel> fields
 */

const pattern = /\+?[0-9\s]*\(?[0-9\s]*\)?[0-9\s]*/;

function init() {
    [...document.querySelectorAll('input[type=tel]')].forEach((node) => {
        node.setAttribute('maxlength', '14');
        node.addEventListener('input', onInput);
    });
}

function onInput(event) {
    const input = event.currentTarget;
    const { value } = input;
    window.field.alert(input); // clear any existing errors or warnings
    if (value !== pattern.exec(value)[0]) {
        window.field.alert(input, 'Contains invalid characters');
    }
}

document.addEventListener('DOMContentLoaded', init);
